module.exports = __webpack_public_path__ + "img/resource.2632d91f.png";